module.exports = __webpack_public_path__ + "static/media/tab-house-crunchy.4fb25aad.png";